import { CourseInstance } from './course-instance.model';


export class Registration {
  public iri: string;
  public id: string;
  public object: string | CourseInstance;
  public agent: string | { id?: string; link: string };
  public registrationDate: Date;
  public isOnWaitList: boolean;
  public isAbsent: boolean;

  constructor(json?) {
    if (json) {
      this.iri = json['@id'];
      this['@type'] = json['@type'];
      this.id = json.id;
      this.object = json.object ? new CourseInstance(json.object) : json.object;
      this.agent = json.agent;
      this.registrationDate = json.registrationDate;
      this.isOnWaitList = json.isOnWaitList;
      this.isAbsent = json.isAbsent;
    }
  }
}
